import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/diy/components/DIYInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/home-page/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
